export const GIFTCARD_BALANCE_SUCESS = 'GIFTCARD_BALANCE_SUCESS';
export const GIFTCARD_BALANCE_ERROR = 'GIFTCARD_BALANCE_ERROR';
export const GIFTCARD_BALANCE_LOADING = 'GIFTCARD_BALANCE_LOADING';
export const GIFTCARD_BALANCE_RESET = 'GIFTCARD_BALANCE_RESET';
